/*
 * Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext, useEffect, useState } from "react";
import { Button, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ImageEditContext } from "cms/images/image-selector/context/image-edit-context";
import LabelledField from "components/labelled-field";
import { TabPanel } from "cms/images/image-selector/dialog-edit/panels/tab-panel";
// import { ImageKeywordsEditor } from 'cms/images/image-selector/dialog-edit/panels/image-keywords-editor'
import { SVGIcons } from "cms/icons/svg-icons";
import { useSnackbar } from "hooks/useSnackbar";

const ImageEditPropertiesPanel = () => {
    const { t }  = useTranslation();
    const imageEditContext = useContext(ImageEditContext);
    const hasImage = imageEditContext.hasImage;
    const selectedImage = imageEditContext?.selectedImage;
    // const onSaveImage = imageEditContext?.onSaveImage;
    const localState = imageEditContext?.localState;
    const setLocalState = imageEditContext?.setLocalState;
    const selectedEditTab = imageEditContext?.selectedEditTab;
    // const image = imageEditContext?.image;
    const setImage = imageEditContext?.setImage;
    const setHasChanges = imageEditContext?.setHasChanges;
    const setIsFieldValid = imageEditContext?.setIsFieldValid;

    const { showSnackbar } = useSnackbar();
    const [errors, setErrors] = useState({ title: false, alt: false });

    useEffect(() => {
        setLocalState({
            image: selectedImage,
            // keywords: keywords || []
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedImage]);

    useEffect(() => {
        const newErrors = {
            title: !localState?.image?.title?.trim(),
            alt: !localState?.image?.alt?.trim(),
        };
        setErrors(newErrors);
        const isValid = !newErrors.title && !newErrors.alt;
        setIsFieldValid(isValid);
    }, [localState?.image?.title, localState?.image?.alt, setIsFieldValid]);
    
    const updateImage = (change) => {
        const updatedImage = {
            ...localState?.image,
            ...change
        };
        setImage(updatedImage);
        setLocalState({
            image: updatedImage,
            // keywords: localState?.keywords
        });
    };
    
    // const [keywords, setKeywords] = useState([])
    // const onChangeKeywords = (value) => {
    //     const change = {keywords: value}
    //     //TODO: implement saving keywords.
    //     //  keywords will be separate from the image or model records
    //     const updatedKeywords = [...keywords, change]
    //     setKeywords(updatedKeywords)
    //     // const updatedKeywords = [
    //     //     ...localState?.keywords,
    //     //     change
    //     // ]
    //     // setLocalState({
    //     //     image: localState?.image,
    //     //     keywords: updatedKeywords
    //     // })
    // }
    
    const onChange = (value, property) => {
        const change = {
            [property]: value
        };
        updateImage(change);
        setHasChanges(true);
    };
    
    const onChangeTitle = (event) => {
        const value = event.target.value;
        onChange(value,"title");
    };

    const onChangeAlt = (event) => {
        const value = event.target.value;
        onChange(value,"alt");
    };

    const onChangeDescription = (event) => {
        const value = event.target.value;
        onChange(value,"description");
    };

    const onCopyToClipboard = () => {
        navigator.clipboard.writeText(localState?.image?.guid);
        showSnackbar("Copied to system clipboard");
    };

    return (
        <Fragment>
            <TabPanel value={selectedEditTab} index={0}>

                {hasImage && (
                    <>
                        <h3 className="sectionHeader">
                            Identifiers
                        </h3>
                        
                        <LabelledField label={t("commons.title")} isRequired={true} className='labelField image-edit-panel' tooltip={t("commons.titleTooltip")}>
                            <TextField
                                onChange={onChangeTitle}
                                id='image-title'
                                fullWidth
                                variant="outlined"
                                value={localState?.image?.title || ""}
                                error={errors.title}
                                className={"noBoxShadow"}
                            />
                        </LabelledField>
                        
                        <LabelledField label={t("commons.guid")} className="labelField image-edit-panel" tooltip={t("commons.guidTooltip")}>
                            <div className="form-id-area guid-text-field">
                                <p>{localState?.image?.guid}</p>
                                <Button
                                    className="copyButton image-edit-details"
                                    startIcon={<SVGIcons.common.Copy/>}
                                    onClick={onCopyToClipboard}
                                />
                            </div>
                        </LabelledField>
                        
                        <h3 className="sectionHeader">
                            Properties
                        </h3>
                        
                        <LabelledField label={t("commons.altText")} isRequired={true} className='labelField image-edit-panel' tooltip={t("commons.altTextTooltip")}>
                            <TextField
                                onChange={onChangeAlt}
                                id='image-alt'
                                multiline
                                rows={1.5}
                                fullWidth
                                error={errors.alt}
                                placeholder='Add alt text'
                                variant="outlined"
                                value={localState?.image?.alt || ""}
                                className={"noBoxShadow"}
                            />
                        </LabelledField>

                        <LabelledField label={t("commons.caption")} className='labelField image-edit-panel' tooltip={t("commons.captionTooltip")}>
                            <TextField
                                onChange={onChangeDescription}
                                id='image-description'
                                multiline
                                rows={1.5}
                                fullWidth
                                placeholder='Add a caption'
                                value={localState?.image?.description || ""}
                                className={"noBoxShadow"}
                            />
                        </LabelledField>
                        
                        {/*<LabelledField label="Keywords" className='labelField'>*/}
                        {/*    <ImageKeywordsEditor*/}
                        {/*        onChange={(value) => onChangeKeywords(value)}*/}
                        {/*        keywords={localState?.keywords || []}*/}
                        {/*    />*/}
                        {/*</LabelledField>*/}
                        
                    </>
                )}
            </TabPanel>
        </Fragment>
    );
};

export { ImageEditPropertiesPanel };
